module.exports = __webpack_public_path__ + "img/2022.06.74b34dca.jpg";